module.exports = __webpack_public_path__ + "static/media/done.661cf1dc.svg";